import "./Header.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import { GetSpecificOrganization } from "@services/client-list.service";
import { clientLogout } from "@services/auth.service";
export default function StaticHeader(props: any) {
  const navigate = useNavigate();

  return (
    <header className="header-wrapper">
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center cursor-pointer">
          {/* <a className="submenu-toggler-holder">
            <img src="/images/toggler-icon.svg" className="img-fluid " />
          </a> */}
          <a href="" className="d-inline-block">
            <img
              src={
                getValue(localStorage, `organisation_logo`, "")
                  ? getValue(localStorage, `organisation_logo`, "")
                  : "/images/lexcare_logo.jpeg"
              }
              width="173"
              height="52"
              className="img-fluid header-wrapper__logo"
            />
          </a>
        </div>
        <div className="bulk-dropdown"></div>
      </div>
    </header>
  );
}
